<template>
<div id="details-left">
  <div class="columns">
    <div class="column">
      <p class="el-p">Browser</p>
      <p class="el-p">IP</p>
      <p class="el-p">accessToken</p>
    </div>
    <div class="column">
      <p class="el-p">{{ browser}}</p>
      <p class="el-p glitch-1" :data-text="ip">{{ ip }}</p>
      <p class="el-p glitch-2" :data-text="accessToken">{{ accessToken }}</p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'detailsLeft',
  data() {
    return {
      accessToken: 'Invalid',
      ip: '127.0.0.1',
      browser: 'UNDEFINED',

    }
  },
  methods: {
    randomizer(values, bool) {
      let i, pickedValue,
        randomNr = Math.random(),
        threshold = 0;

      for (i = 0; i < values.length; i++) {
        if (values[i].probability === '*') {
          continue;
        }

        threshold += values[i].probability;
        if (threshold > randomNr) {
          pickedValue = values[i].value;
          break;
        }

        if (!pickedValue) {
          //nothing found based on probability value, so pick element marked with wildcard
          pickedValue = values.filter((value) => value.probability === '*');
        }
      }

      if (bool) {
        this.ip = pickedValue;
      } else {
        this.accessToken = pickedValue;
      }
    },

  },
  created() {
    if (this.isMobile) return
    this.$options.glitchArray = [{
        value: 'Va$li#',
        probability: 0.1
      },
      {
        value: 'I§v=li9',
        probability: 0.1
      },
      {
        value: '5alid',
        probability: 0.1
      },
      {
        value: 'Valid',
        probability: 0.3
      },
      {
        value: 'V&)%!/',
        probability: 0.1
      },
      {
        value: 'Invalid',
        probability: 0.3
      }
    ]
    this.$options.randomIps = [{
        value: '202.57.59.139',
        probability: 0.05,
      },
      {
        value: '35.201.69.218',
        probability: 0.05,
      },
      {
        value: '80.176.86.145',
        probability: 0.05,
      },
      {
        value: '235.200.121.7',
        probability: 0.05,
      },
      {
        value: '32.44.151.12',
        probability: 0.05,
      },
      {
        value: '234.153.49.248',
        probability: 0.05,
      },
      {
        value: '171.149.154.86',
        probability: 0.05,
      },
      {
        value: '63.103.142.154',
        probability: 0.05,
      },
      {
        value: '75.159.49.229',
        probability: 0.05,
      },
      {
        value: '144.130.213.129',
        probability: 0.05,
      },
      {
        value: '140.230.3.104',
        probability: 0.05,
      },
      {
        value: '114.217.180.129',
        probability: 0.05,
      },
      {
        value: '201.172.0.150',
        probability: 0.05,
      },
      {
        value: '55.136.197.165',
        probability: 0.05,
      },
      {
        value: '246.179.4.130',
        probability: 0.05,
      },
      {
        value: '238.119.134.178',
        probability: 0.05,
      },
      {
        value: '219.99.6.223',
        probability: 0.05,
      },
      {
        value: '149.207.198.164',
        probability: 0.05,
      },
      {
        value: '127.0.0.1',
        probability: 0.05,
      },
      {
        value: 'UNDEFINED',
        probability: 0.05,
      }
    ]
  },
  destroyed() {
    clearInterval(this.$options.intervalAccessToken);
    clearInterval(this.$options.intervalIps);

  },
  mounted() {


    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    var isChromium = window.chrome,
      winNav = window.navigator,
      vendorName = winNav.vendor,
      isOpera = winNav.userAgent.indexOf("OPR") > -1,
      isIEedge = winNav.userAgent.indexOf("Edge") > -1,
      isIOSChrome = winNav.userAgent.match("CriOS");

    if (isIOSChrome || (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera === false && isIEedge === false)) {
      // is Google Chrome
      isChrome = true
      isFirefox = false
    }

    function getKeyByValue(object, value) {
      return Object.keys(object).filter(key => object[key] === value)[0];
    }


    var all = {
      'Opera': isOpera,
      'Firefox': isFirefox,
      'Safari': isSafari,
      'Internet Explorer': isIE,
      'Edge': isEdge,
      'Chrome': isChrome,
      'Other': isBlink,
      'UNDEFINED': true
    }
    // this.browser = all.filter((e) => e == true)[0];
    this.browser = getKeyByValue(all, true);

    var self = this;
    this.$options.intervalAccessToken = setInterval(function() {
      self.randomizer(self.$options.glitchArray, false)
    }, 1000 / 5);
    this.$options.intervalIps = setInterval(function() {
      self.randomizer(self.$options.randomIps, true)
    }, 1000 / 1)
  }
}
</script>

<style lang="scss">
$primaryColor: #00ff00;
$secondaryColor: transparent;
$steps: 20;

body {
    background-color: $secondaryColor;
    padding: 100px;
}

.glitch-1 {
    position: relative;
    // margin: 0 auto;
    color: $primaryColor;
    transform: scale3d(1,1,1);

    &::after,
    &::before {
        content: attr(data-text);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        overflow: hidden;
        background: $secondaryColor;
        color: $primaryColor;
        clip: rect(0, 900px, 0, 0);

    }

    &::before {
        left: 7px;
        text-shadow: 2px 0 green;
        animation: glitch-effect 2s infinite linear alternate-reverse;
    }

    &::after {
        left: 3px;
        text-shadow: -2px 0 red;
        animation: glitch-effect 2s infinite linear alternate-reverse;
    }
}

.glitch-2 {
    position: relative;
    // margin: 0 auto;
    color: $primaryColor;
    transform: scale3d(1,1,1);

    &::after,
    &::before {
        content: attr(data-text);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        overflow: hidden;
        background: $secondaryColor;
        color: $primaryColor;
        clip: rect(0, 900px, 0, 0);

    }

    &::before {
        left: 7px;
        text-shadow: 3px 0 green;
        animation: glitch-effect 1s infinite linear alternate-reverse;
    }

    &::after {
        left: 3px;
        text-shadow: -3px 0 red;
        animation: glitch-effect 3s infinite linear alternate-reverse;
    }
}

@keyframes glitch-effect {

    @for $i from 0 through $steps {
        #{percentage($i*(1/$steps))} {
            clip: rect(random(100)+px,9999px,random(100)+px,0);
        }
    }

}

#details-left {
    pointer-events: none;
    position: fixed;
    font-size: 0.7em;
    left: 0;
    bottom: 0;
    padding: 2em;
    z-index: 2;
    user-select: none;
    /* width: 20vw; */
}
</style>
